module.exports = __webpack_public_path__ + "img/bear9.09a7828a.svg";